import EditorHtml from "./EditorHtml";

export default EditorHtml;
